import { BCMSRecord, useBCMSContext, useModel, useParams, Workflow } from "@bcm-dev/bcms-vite";
import TransferConfirmPage from "components/pages/TransferConfirmPage";
import TransferReviewPage from "components/pages/TransferReviewPage";
import TransfersPage from "components/pages/TransfersPage";
import Classes, { TransferTemplate, TransferTransaction } from "model";
import MakeTransfer from "./classes/MakeTransfer";
// Steps of the workflow
const steps = [ TransfersPage, TransferReviewPage, TransferConfirmPage ];

export default function MakeTransferWorkflow(props) {
    // Initalize global controller
    const controller = useBCMSContext();
    const { stepID, transferID } = useParams();
    const model = useModel();
    const { branding } = useModel();
    
    // Get the default autopay and return the workflow component
    const value = getDefaultTransfer(controller, model, transferID);
   
    const constructor = record => {
        const defaultValues = getDefaultTransfer(controller, model, transferID);
        const data = { ...defaultValues.data, transfer: MakeTransfer.init(record) };

        return { ...defaultValues, data };
    };
    
    return <Workflow value={ value } steps={ steps } step={ stepID } constructor={ constructor } />
}
// getDefaultTransfer :: bcmsGlobalController, STRING -> {  }
// Initalize and return the default information for the workflow
export const getDefaultTransfer = (controller, model, transferID) => {
    BCMSRecord.globalControllerFor(Classes, controller);
    const user = model ? model.user : {};

    // Note: user settings determine how transfers are made, 
    // so using templates, using only templates, or no templates at all.
    const allowTransferOnlyTemplates = user.allowTransferOnlyTemplates === "true";
    let editTransfer = undefined;
    let editMakeTransfer = undefined;

    if(typeof transferID === "string") {
        editTransfer = TransferTransaction.initByID(transferID);
        editMakeTransfer = MakeTransfer.init(editTransfer, model.branding)
        editMakeTransfer.templateOnly = allowTransferOnlyTemplates;
    }

    //const transfer = MakeTransfer.init({ templateOnly: allowTransferOnlyTemplates });
    const transfer = editMakeTransfer ? editMakeTransfer : MakeTransfer.init({ templateOnly: allowTransferOnlyTemplates }, model.branding);

    return {
        data: {
            transfer: transfer,
            transferTemplates: TransferTemplate.initAll(),
            editingTransfer: { isEditing: transferID ? "true" : "false" },
            editingTransferID: { id: transferID }
        }
    };
};

// Return the steps of the workflow
export const getWorkflowSteps = () => steps;